import posthog from 'posthog-js';
import type { BeforeSendFn, PostHogConfig } from 'posthog-js';
import { getPlatform } from '@/api/config';
import { scrubSensitiveData } from './scrubSensitiveParams';

const proxyHost = import.meta.env.VITE_POSTHOG_HOST?.trim() ?? '';
const rawKey = import.meta.env.VITE_POSTHOG_KEY?.trim() ?? '';

export const IS_POSTHOG_CONFIGURED =
  rawKey.length > 0 && proxyHost.length > 0 && import.meta.env.VITE_POSTHOG_ENABLED === 'true';

export const POSTHOG_PROJECT_API_KEY = rawKey;

export const POSTHOG_PROXY_HOST = proxyHost;

// Pageviews, autocapture and exceptions carry the current URL, which briefly holds the emailed
// reset/invite `token_hash` (and an OAuth `code` on the callback) before the page strips it.
export const scrubPosthogEvent: BeforeSendFn = (event) => (event ? scrubSensitiveData(event) : event);

export const POSTHOG_PROVIDER_OPTIONS: Partial<PostHogConfig> = {
  api_host: proxyHost,
  capture_pageview: true,
  capture_pageleave: true,
  capture_exceptions: true,
  before_send: scrubPosthogEvent,
  // CapacitorHttp (Android) JSON-serializes Uint8Array bodies as {}, losing the
  // gzip payload entirely. Disabling compression makes PostHog send plain JSON
  // text, which CapacitorHttp handles correctly. Not in public types — cast needed.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ...(getPlatform() === 'android' ? ({ disable_compression: true } as any) : {}),
  loaded: (ph) => {
    ph.register({ platform: getPlatform() });
    ph.setPersonProperties({
      environment: process.env.NODE_ENV,
    });
    ph.reloadFeatureFlags();
  },
};

export { posthog };
